'use strict';
const mmWidgets = require('../widgets/mm-widgets');

mmWidgets.fn.subteamMemberWidget = function (subteamModel, subteam, member, container) {
	if (!subteamModel || !subteam || !member || !container) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this,
			memberEmail = member.isMe ? `${member.email} (you)` : member.email;
		element.find('[data-mm-role~="member-email"]').text(memberEmail);
		element.find('[data-mm-role~="member-role"]').text(member.role);
		if (!member.isMe) {
			const roleChanger = element.find(`[data-mm-sub-team-role~="${member.role}"][data-mm-sub-team-role-required~="${subteam.role}"]`);
			roleChanger.removeClass('hidden')
			.click(function (e) {
				const newRole = e.currentTarget.getAttribute('data-mm-sub-team-to-role');
				if (newRole) {
					container.showProgressMessage('Updating member role, please wait...');
					subteamModel.changeMemberRole(subteam, member, newRole)
					.then(result => {
						container.trigger(mmWidgets.Event('memberList', {memberList: result}));
					})
					.catch(reason => container.showError(reason));
				} else {
					container.showProgressMessage('Removing member, please wait...');
					subteamModel.removeMember(subteam, member)
					.then(result => {
						container.trigger(mmWidgets.Event('memberList', {memberList: result}));
					})
					.catch(reason => container.showError(reason));
				}
			});
		}

	});

};
